import { render, staticRenderFns } from "./offenceDialog.vue?vue&type=template&id=d81478de&scoped=true&"
import script from "./offenceDialog.vue?vue&type=script&lang=ts&"
export * from "./offenceDialog.vue?vue&type=script&lang=ts&"
import style0 from "./offenceDialog.vue?vue&type=style&index=0&id=d81478de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81478de",
  null
  
)

export default component.exports